module.exports = __webpack_public_path__ + "media/images/arrows/twisted/seledyn-down-8f7b151b65269ff1db628a5d35c60c64.svg";